export const formatCurrencyPKR = (value) => {
  const num = Number(String(value).replace(/,/g, '')) || 0;

  // Always show full numbers with commas (no K/M abbreviation)
  return num.toLocaleString('en-PK', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};


